/**
 * Saved Parts page renderer.
 * Reads the browser-local saved list, renders snapshot cards immediately,
 * then refreshes each record from the product JSON endpoint.
 */
(function () {
  if (window.icsSavedPartsPageAttached) return;
  window.icsSavedPartsPageAttached = true;

  const list = document.querySelector("[data-saved-parts-list]");
  if (!list) return;

  const empty = document.querySelector("[data-saved-parts-empty]");
  const loading = document.querySelector("[data-saved-parts-loading]");
  const toolbar = document.querySelector("[data-saved-parts-toolbar]");
  const clearButton = document.querySelector("[data-saved-parts-clear]");
  const countElement = document.querySelector("[data-saved-count]");
  const rfqButton = document.querySelector("[data-saved-parts-rfq]");
  const refreshButton = document.querySelector("[data-saved-parts-refresh]");

  let renderedHandles = new Set();

  function money(value) {
    const numeric = Number(value);
    if (!Number.isFinite(numeric) || numeric <= 0) return "";
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
    }).format(numeric);
  }

  function cardMarkup(part, live) {
    const data = live || part;
    const title = data.title || data.handle || "Saved part";
    const vendor = data.vendor || part.vendor || "To be confirmed";
    const price = money(data.price !== undefined ? data.price : part.price);
    const image = data.image || data.featured_image || part.image || "";
    const url = data.url || part.url || "/products/" + data.handle;
    const source = live ? "Updated from catalog" : "Saved snapshot";

    return [
      '<article class="ics-saved-card" data-saved-card data-handle="' + escapeAttr(data.handle) + '">',
      image
        ? '<a class="ics-saved-card__image" href="' + escapeAttr(url) + '"><img src="' + escapeAttr(image) + '" alt="" loading="lazy"></a>'
        : '<a class="ics-saved-card__image ics-saved-card__image--empty" href="' + escapeAttr(url) + '">IC</a>',
      '<div class="ics-saved-card__body">',
      '<p class="ics-saved-card__eyebrow">' + escapeHtml(vendor) + "</p>",
      '<h3 class="ics-saved-card__title"><a href="' + escapeAttr(url) + '">' + escapeHtml(title) + "</a></h3>",
      '<p class="ics-saved-card__meta">' + escapeHtml(data.handle || "") + "</p>",
      '<p class="ics-saved-card__note">' + escapeHtml(source) + "</p>",
      "</div>",
      '<div class="ics-saved-card__side">',
      price
        ? '<span class="ics-saved-card__price">' + escapeHtml(price) + "</span>"
        : '<span class="ics-saved-card__price ics-saved-card__price--quote">Quote required</span>',
      '<a class="ics-saved-card__rfq" href="' + escapeAttr(rfqHref(data)) + '">Request quote</a>',
      '<button type="button" class="ics-saved-card__remove" data-remove-handle="' + escapeAttr(data.handle) + '">Remove</button>',
      "</div>",
      "</article>",
    ].join("");
  }

  function rfqHref(data) {
    const part = data.title || data.handle || "";
    const vendor = data.vendor || "";
    return (
      "/pages/bom-rfq?part=" +
      encodeURIComponent(part) +
      "&manufacturer=" +
      encodeURIComponent(vendor)
    );
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function escapeAttr(value) {
    return escapeHtml(value);
  }

  function render(parts, markLive) {
    renderedHandles = new Set();
    if (!parts.length) {
      list.hidden = true;
      if (empty) empty.hidden = false;
      if (toolbar) toolbar.hidden = true;
      return;
    }
    list.hidden = false;
    if (empty) empty.hidden = true;
    if (toolbar) toolbar.hidden = false;
    list.innerHTML = parts
      .map(function (part) {
        renderedHandles.add(part.handle);
        return cardMarkup(part, markLive ? part._live : null);
      })
      .join("");
    if (countElement) countElement.textContent = String(parts.length);
  }

  async function refreshLive(parts) {
    const updated = parts.map(function (part) {
      return fetch("/products/" + encodeURIComponent(part.handle) + ".js")
        .then(function (response) {
          if (!response.ok) throw new Error("fetch failed");
          return response.json();
        })
        .then(function (json) {
          return Object.assign({}, part, {
            _live: {
              handle: json.handle,
              title: json.title,
              vendor: json.vendor,
              url: json.url,
              image: json.featured_image || "",
              price: json.price,
            },
          });
        })
        .catch(function () {
          return part;
        });
    });
    return Promise.all(updated);
  }

  function setLoading(state) {
    if (!loading) return;
    loading.hidden = !state;
    list.hidden = state;
  }

  async function load() {
    const saved = window.icsSavedParts ? window.icsSavedParts.read() : [];
    setLoading(true);
    render(saved, false);
    const refreshed = await refreshLive(saved);
    setLoading(false);
    render(refreshed, true);
  }

  list.addEventListener("click", function (event) {
    const remove = event.target.closest("[data-remove-handle]");
    if (!remove) return;
    const handle = remove.dataset.removeHandle;
    if (window.icsSavedParts) {
      window.icsSavedParts.remove(handle);
    }
    const card = remove.closest("[data-saved-card]");
    if (card) card.remove();
    const remaining = list.querySelectorAll("[data-saved-card]").length;
    if (countElement) countElement.textContent = String(remaining);
    if (remaining === 0 && window.icsSavedParts) {
      load();
    }
  });

  if (clearButton) {
    clearButton.addEventListener("click", function () {
      if (window.icsSavedParts) {
        window.icsSavedParts.clear();
      }
      load();
    });
  }

  if (refreshButton) {
    refreshButton.addEventListener("click", load);
  }

  document.addEventListener("ics:saved-parts:changed", function (event) {
    if (event.detail && event.detail.count === 0 && list.querySelectorAll("[data-saved-card]").length) {
      load();
    }
  });

  load();
})();
